import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {FeltMedInternlenker, LenkerelasjonModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {StrengMalPipe} from "felles-ng2/pipes/StrengMalPipe";
import {MatIcon} from "@angular/material/icon";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {caseForEnumMangler} from "felles-ng2/støttefunksjoner/enumer";

const debug = initDebugger('ListeInnkommendeLenkerelasjonerKomponent');

/**
 * Lister lenkerelasjoner
 */
@Component({
    selector: 'liste-lenkerelasjoner',
    templateUrl: 'liste-lenkerelasjoner.html',
    styleUrl: 'liste-lenkerelasjoner.scss',
    imports: [
        StrengMalPipe,
        MatIcon
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListeLenkerelasjonerKomponent {
    static ajsSelector = 'listeLenkerelasjoner';

    lenker = input.required<LenkerelasjonModell[]>();

    constructor(private navigasjon: Navigasjon, private oversettelser: Oversettelser) {
    }

    navigerTilKilde(lenke: LenkerelasjonModell) {
        this.navigasjon.gåTilEntitetRef(lenke.kildeentitet);
    }

    kildefelt(lenke: LenkerelasjonModell) {
        switch (lenke.kildefelt) {
            case FeltMedInternlenker.møteFormål:
                return this.oversettelser.oversett(i18n('Nevnt i møteformål i'));
            case FeltMedInternlenker.sakBeskrivelse:
                return this.oversettelser.oversett(i18n('Nevnt i saksbeskrivelsen i'));
            case FeltMedInternlenker.sakReferat:
                return this.oversettelser.oversett(i18n('Nevnt i saksprotokoll i'));
            case FeltMedInternlenker.beslutningBeskrivelse:
                return this.oversettelser.oversett(i18n('Nevnt i beslutningsbeskrivelse i'));
            case FeltMedInternlenker.oppgaveBeskrivelse:
                return this.oversettelser.oversett(i18n('Nevnt i oppgavebeskrivelsen i'));
            default:
                caseForEnumMangler(lenke.kildefelt);
        }
    }
}
